import JourneyContinuation from './journeyContinuation';

export default {
    [JourneyContinuation.YES]: 'Ja',
    [JourneyContinuation.NO]: 'Nein',
    [JourneyContinuation.EMPTY_TRIP]: 'Leerfahrt',
};
